import React, { useMemo, useState } from 'react';
import Container from "../../common/Container";
import styles from './Download.module.css';
import PdfViewer from 'common/PdfViewer';
import { getAllData } from 'apis/customApiHandler';
import { BiCloudDownload } from 'react-icons/bi';
import { IoMdPrint } from "react-icons/io";

export const DownloadAggrement = ({ data,selectedAgreement }) => {
  console.log('selectedAgreement--',selectedAgreement);
  const [fileUrl, setFileUrl] = useState(null);
  const [fileType, setFileType] = useState(null);

  console.log('data----',data);

  const getFile = async () => { 
    try {
      const response = await fetch(selectedAgreement?selectedAgreement?.document:data);
      const arrayBuffer = await response.arrayBuffer();
      const blob = new Blob([arrayBuffer], { type: response.headers.get('content-type') });
      const url = window.URL.createObjectURL(blob);
      
      setFileUrl(url);
      setFileType(response.headers.get('content-type'));
    } catch (error) {
      console.error('Error fetching the file:', error);
    }
  };

  useMemo(() => {
     getFile();
  }, [selectedAgreement,data]);

  const handlePrint = () => {
    if (fileUrl) {
      const printWindow = window.open(fileUrl);
      if (!printWindow) {
        alert('Please enable pop-ups for printing.');
      } else {
        printWindow.print();
      }
    } else {
      console.error("File data is not available for printing.");
    }
  };

  const fetchFile = async () => {
    const documentUrl = selectedAgreement ? selectedAgreement.document : data;
    try {
      const response = await fetch(documentUrl);
      const blob = await response.blob();
      const url = URL.createObjectURL(blob);
      const link = document.createElement("a");
      link.href = url;
      link.download = documentUrl.split("/").pop();
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
    } catch (error) {
      console.error("Error downloading the file:", error);
    }
  };

  console.log('fileUrl--',fileUrl);

  return (
    <Container className="download_agreement">

      <div className="justify-between flex w-full">

      <div className="font-lg underline"> Latest Agreement: </div>
      <div className="flex flex-row gap-2 w float-right mb-4 h-10 ">
      <IoMdPrint 
      className="w-8 h-8 text-blue-500 hover:scale-105 cursor-pointer text-center mb-10"
      onClick={() => {
        handlePrint();
      }}
      />

      <BiCloudDownload
        className="w-8 h-8 text-green-500 hover:scale-105 cursor-pointer text-center mb-10"
        onClick={() => {
          fetchFile();
        }}
      />
      
      </div>

      </div>

      <div className="w-full flex flex-col md:flex-row justify-between mb-10 border border-2 shadow-md rounded-sm p-1">
        {fileUrl && (
          fileType === 'application/pdf' ? (
            <PdfViewer pdfBytes={fileUrl} />
          ) : (
            <iframe src={fileUrl} height="400px" width="100%" title="Document Viewer" style={{ overflow: 'hidden' }}/>
          )
        )}
      </div>
    </Container>
  );
};

